import React from "react";
import styles from "./PaymentInfoCard.module.css";
import { Copy } from "lucide-react";
import Column from "../../../components/ui/Stack/Column";
import HStack from "../../../components/ui/Stack/HStack";
import { useTranslation } from "react-i18next";
import { useFetchBankAccounts } from "../../../hooks/fetch-data/useFetchBankAccounts";
import { QRCodeSVG } from "qrcode.react";

const PaymentInfoCard = ({ loanInfo }) => {
  const { t } = useTranslation("payment");
  const { data: bankAccounts } = useFetchBankAccounts();

  // Filter deposit accounts and use first one
  const depositAccount = bankAccounts?.[0];

  const bankDisplayName = depositAccount?.bank?.toUpperCase() || t("BANK_COMPANY");
  const accountName = depositAccount?.bank_name || t("COMPANY_NAME");
  const bankNumber = depositAccount?.account_number || "-";

  const handleCopy = () => {
    navigator.clipboard.writeText(bankNumber);
    alert(t("alert"));
  };

  return (
    <div className={styles.card}>
      <Column gap={3} fullWidth justify="start" align="start">
        <h3 className={styles.title}>{t("paymentInfo")}</h3>
        <HStack fullWidth justify="between">
          <p className={styles.companyName}>{accountName}</p>
          <p className={styles.bankCompanyName}>{bankDisplayName}</p>
        </HStack>
        <HStack fullWidth justify="between">
          <Column align="start">
            <p className={styles.bankAccountNumberTitle}>{t("bankId")}</p>
            <p className={styles.bankAccountNumber}>{bankNumber}</p>
          </Column>
          <button className={styles.copyBtn} onClick={handleCopy}>
            <span className={styles.copyIcon}>
              <Copy />
            </span>
            {t("copy")}
          </button>
        </HStack>

        {/* QR Code for bank account */}
        {bankNumber && bankNumber !== "-" && (
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginTop: 12,
            padding: "10px 14px",
            backgroundColor: "#fff",
            borderRadius: 10,
            border: "1px solid var(--color-border, #E6E4E4)",
          }}>
            <QRCodeSVG
              value={bankNumber}
              size={80}
              level="M"
              includeMargin={false}
            />
            <p style={{
              fontSize: 12,
              color: "var(--color-text-secondary, #78706E)",
              lineHeight: 1.5,
            }}>
              สแกน QR Code<br />เพื่อดูเลขที่บัญชี
            </p>
          </div>
        )}
      </Column>
    </div>
  );
};

export default PaymentInfoCard;
